import { render } from "./QuestionCollections.vue?vue&type=template&id=fa7012d0"
import script from "./QuestionCollections.vue?vue&type=script&lang=ts"
export * from "./QuestionCollections.vue?vue&type=script&lang=ts"
script.render = render

export default script